import { render, staticRenderFns } from "./capt_xu_transaction.vue?vue&type=template&id=2cead20c"
import script from "./capt_xu_transaction.vue?vue&type=script&lang=js"
export * from "./capt_xu_transaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports